import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '../../Checkbox/Checkbox';
import style from './TableToolbar.module.css';

function TableToolbar({
  tools = [],
  onClickCheckbox,
  openTools = false,
  additionalTools = [],
}) {
  const [checked, setChecked] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    setChecked(openTools);
    setAnchorEl(null);
  }, [openTools]);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={style.container}>
      <Checkbox
        color="secondary"
        className={style.checkbox}
        checked={checked}
        onChange={() => {
          setChecked(!checked);
          onClickCheckbox(!checked);
        }}
      />
      {openTools &&
        tools &&
        tools.map((tool) => (
          <button
            type="button"
            key={tool.value}
            className={style.tool}
            onClick={tool.onClick}
          >
            {tool.icon
              ? React.createElement(tool.icon, { className: style.icon })
              : null}
            <span className={style.text}>{tool.text}</span>
          </button>
        ))}
      {openTools && additionalTools ? (
        <>
          <MoreVertIcon
            onClick={handleClick}
            className={style.additionalToolsIcon}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {additionalTools.map((tool) => (
              <MenuItem
                key={tool.value}
                onClick={tool.onClick}
                disabled={tool.disabled}
              >
                {tool.text}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : null}
    </div>
  );
}

TableToolbar.propTypes = {
  openTools: PropTypes.bool,
  onClickCheckbox: PropTypes.func.isRequired,
  tools: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.elementType,
      text: PropTypes.string,
      value: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  additionalTools: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
};

export default TableToolbar;
